import { useTheme } from '@repo/theme';
import { UtilityText } from 'component/text';
import { useEffect, useState } from 'react';
import { ActivityIndicator, StyleSheet, View } from 'react-native';
import type { FormatParams, TLabel } from 'util/stdtypes';
import { t } from 'util/stdtypes';

type LoadingSpinnerProps = {
    label?: TLabel;
    formatParams?: FormatParams;
};

export function LoadingSpinner({ label = t('loading', 'Loading...'), formatParams }: LoadingSpinnerProps) {
    const { colors } = useTheme();
    return (
        <View aria-live='polite' style={s.container}>
            <ActivityIndicator color={colors.colorBorderAccent} size='small' />
            <UtilityText formatParams={formatParams} label={label} type='large' weight='medium' />
        </View>
    );
}

export type LoadingSpinnerContainerProps = { label?: TLabel; formatParams?: FormatParams };

export function LoadingSpinnerContainer({ label, formatParams }: LoadingSpinnerContainerProps) {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const timeout = setTimeout(() => setShow(true), 1000);
        return () => clearTimeout(timeout);
    }, []);

    if (show) {
        return (
            <View style={s.outer}>
                <LoadingSpinner formatParams={formatParams} label={label} />
            </View>
        );
    } else {
        return null;
    }
}

const s = StyleSheet.create({
    container: {
        alignItems: 'center',
        gap: 16,
    },
    outer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
});
